import jump from './jump'
import next from './next'
import previous from './previous'
import { confirm, deconfirm } from './confirm'
import { protect, unprotect } from './protect'

const step = {
  jump,
  next,
  previous,
  confirm,
  deconfirm,
  protect,
  unprotect,
}

export {
  step as default,
  jump,
  next,
  previous,
  confirm,
  deconfirm,
  protect,
  unprotect,
}
